import {
  TodoExternalItemTypeDto,
} from '@act/shared/data-transfer-objects';
import { FilterChips, FlexContainer } from '@act/storybook';
import { useMobile } from '@act/utilities/mobile-context';
import { useFollowUpEventsData } from './hooks/useFollowUpEventsData';
import DocketFollowUpMobileView from './DocketFollowUpMobileView';
import DocketFollowUpTableView from './DocketFollowUpTableView';

interface Filter {
  label: string;
  value: Partial<TodoExternalItemTypeDto>;
}

const filters: Filter[] = [
  { label: 'Calls', value: 'call' },
  { label: 'Feedback', value: 'feedback_call' },
  { label: 'Texts', value: 'message' },
  { label: 'Visits', value: 'visit' },
];

const DocketFollowUpEvents = ({ guideId }: { guideId: string }) => {
  const { isMobile } = useMobile();

  const {
    paginatedEvents,
    filteredEventsCount,
    bounds,
    setBounds,
    setSelectedFilters,
    menuItems,
    handleTableChange,
    canManageMemberFeedback,
  } = useFollowUpEventsData(guideId);

  return (
    <FlexContainer
      direction="column"
      padding={isMobile ? '16px' : '16px 16px 0'}
      height={isMobile ? 'auto' : '100%'}
      width="100%"
      sx={{
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        overflowY: 'visible',
      }}
    >
      <FilterChips
        filterChoices={filters.filter(filter => {
          return canManageMemberFeedback
            ? filter
            : filter.value !== 'feedback_call';
        })}
        setSelectedFilters={setSelectedFilters}
      />

      {isMobile ? (
        <DocketFollowUpMobileView
          events={paginatedEvents}
          totalItems={filteredEventsCount}
          bounds={bounds}
          setBounds={setBounds}
          menuItems={menuItems}
        />
      ) : (
        <DocketFollowUpTableView
          events={paginatedEvents}
          totalRecords={filteredEventsCount}
          bounds={bounds}
          menuItems={menuItems}
          handleTableChange={handleTableChange}
          setBounds={setBounds}
        />
      )}
    </FlexContainer>
  );
};

export default DocketFollowUpEvents;
